export default "__VITE_ASSET__BvFYqf6s__"